import React from 'react';
import { Film, Download, FileText, Award } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';

const Gaff2026 = () => {
  const asianCinema = [
    { id: 1, title: 'S', director: 'Masahiro Ota', country: 'Japan' },
    { id: 2, title: 'Sunday', director: 'Shokir Kholikov', country: 'Uzbekistan' },
    { id: 3, title: 'MA Cry of Silence', director: 'The Maw Naing', country: 'Myanmar' },
    { id: 4, title: 'In The Land of Brothers', director: 'Alireza Ghasemi and Raha Amirfazli', country: 'Iran' },
    { id: 5, title: 'If Only I Could Hibernate', director: 'Zoljargal Purevdash', country: 'Mongolia' },
    { id: 6, title: 'Culi Never Cries', director: 'Pham Ngoc Lan', country: 'Vietnam' },
    { id: 7, title: 'The Shore of Life', director: 'Zhang Chi', country: 'China' },
    { id: 8, title: 'A Poet of River', director: 'Jungkook Han', country: 'South Korea' },
    { id: 9, title: 'Cadet', director: 'Adilkhan Yerzhanov', country: 'Kazakhstan' },
    { id: 10, title: "Let's Have A Cup of Doodh Patti Chai", director: 'Brian Hung', country: 'Hong Kong' }
  ];

  const indianCompetition = [
    { id: 1, title: 'Aājoor', director: 'Aaryan Chandra Prakash', language: 'Bajjika' },
    { id: 2, title: 'Chewing Gum', director: 'Abhay Sharma', language: 'Hindi' },
    { id: 3, title: 'Rador Pakhi (The Morning Sunshine)', director: 'Dr. Bobby Sarma Baruah', language: 'Assamese' },
    { id: 4, title: 'Noi Kotha (River Tales)', director: 'Dr. Pankaj Borah', language: 'Assamese' },
    { id: 5, title: 'Kangbo A Loti (The Lost Path)', director: 'Khanjan Kishore Nath', language: 'Karbi' },
    { id: 6, title: 'Victoria', director: 'Sivaranjini', language: 'Malayalam' },
    { id: 7, title: 'Shape of Momo', director: 'Tribeny Rai', language: 'Nepali' },
    { id: 8, title: 'Imbu', director: 'Shiva Dhwaj Shetty', language: 'Tulu' }
  ];

  const indianNonCompetition = [
    { id: 1, title: "Yakasik Omédé (Yakasi's Daughter)", director: 'Dr. Jayanta Madhab Dutta', language: 'Mising' },
    { id: 2, title: 'Ganaraag', director: 'Dip Bhuyan', language: 'Assamese' },
    { id: 3, title: 'An Evening Ballad', director: 'Bishal Swargiary', language: 'Bodo' },
    { id: 4, title: 'Porobasi (The Ethnic Migration)', director: 'Monet Roy Saha', language: 'Bengali' },
    { id: 5, title: 'Blossoming Almond', director: 'Nehal S. Ghodke', language: 'TBA' },
    { id: 6, title: 'The Woodcutter', director: 'Prakash Deka', language: 'TBA' }
  ];

  const totalFilms = asianCinema.length + indianCompetition.length + indianNonCompetition.length;

  return (
    <div className="min-h-screen bg-black text-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <div className="absolute inset-0" style={{
            backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
            backgroundSize: '40px 40px'
          }}></div>
        </div>

        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-4xl mx-auto text-center mb-12">
            <h1 className="text-7xl md:text-9xl font-bold mb-8 leading-tight">
              GAFF <span className="text-red-500">2026</span>
            </h1>
            <div className="w-24 h-1 bg-red-500 mx-auto mb-8"></div>
            <p className="text-xl text-gray-400">
              2nd Edition • January 22-25, 2026
            </p>
            <p className="text-2xl font-bold mt-4">
              Bringing celebrated voices of Asian cinema to Guwahati
            </p>
          </div>
        </div>

        {/* Decorative Elements */}
        <div className="absolute top-20 right-10 w-32 h-32 border-2 border-red-500/20 rounded-full"></div>
        <div className="absolute bottom-10 left-10 w-24 h-24 border-2 border-red-500/20 rounded-full"></div>
      </section>

      {/* Festival Catalogue Section */}
      <section className="relative bg-black text-white py-32">
        <div className="container mx-auto px-6">
          <div className="max-w-5xl mx-auto">
            <div className="bg-gradient-to-br from-zinc-900 to-black border border-white/10 rounded-2xl p-12 relative overflow-hidden">
              {/* Decorative Elements */}
              <div className="absolute top-0 right-0 w-64 h-64 bg-red-500/5 rounded-full blur-3xl"></div>
              <div className="absolute bottom-0 left-0 w-64 h-64 bg-red-500/5 rounded-full blur-3xl"></div>
              
              <div className="relative z-10 grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
                {/* Left Side - Icon/Illustration */}
                <div className="flex justify-center md:justify-start">
                  <div className="w-48 h-48 bg-red-500/10 rounded-2xl flex items-center justify-center border border-red-500/20">
                    <FileText size={80} className="text-red-500" />
                  </div>
                </div>

                {/* Right Side - Content */}
                <div>
                  <h3 className="text-3xl md:text-4xl font-bold mb-4">
                    FESTIVAL CATALOGUE
                  </h3>
                  <p className="text-gray-400 mb-2">
                    <span className="text-red-500 font-semibold">2nd Edition • 2026</span>
                  </p>
                  <p className="text-gray-300 mb-6 leading-relaxed">
                    Explore our complete festival programme featuring film synopses, director profiles, screening schedules, and special events from 2026 edition.
                  </p>
                  <a
                    href="https://drive.google.com/file/d/1Z48nhFf39ajAgAa6SylMcnP2iGv_Auuk/view?usp=share_link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Button 
                      size="lg"
                      className="bg-red-500 text-white hover:bg-red-600 transition-all duration-300 group"
                    >
                      <Download size={20} className="mr-2 group-hover:animate-bounce" />
                      Download Catalogue
                    </Button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-5 pointer-events-none">
          <div className="absolute inset-0" style={{
            backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
            backgroundSize: '40px 40px'
          }}></div>
        </div>
      </section>

      {/* Awards Section */}
      <section className="py-20 bg-gradient-to-b from-black to-zinc-900">
        <div className="container mx-auto px-6">
          <div className="max-w-5xl mx-auto">
            <div className="text-center mb-16">
              <Award size={48} className="text-yellow-500 mx-auto mb-4" />
              <h2 className="text-4xl md:text-5xl font-bold mb-4">
                AWARDS & RECOGNITION
              </h2>
              <p className="text-xl text-gray-400">
                India Showcase Competition
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-white/5 border border-white/10 rounded-2xl p-6 hover:border-yellow-500/50 transition-all duration-300">
                <div className="flex items-start gap-4">
                  <Award size={24} className="text-yellow-500 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="text-xl font-bold mb-2 text-yellow-500">
                      Best Film
                    </h3>
                    <p className="text-white font-semibold mb-1">Victoria (Malayalam)</p>
                    <p className="text-sm text-gray-400">Dir. Sivaranjini</p>
                  </div>
                </div>
              </div>

              <div className="bg-white/5 border border-white/10 rounded-2xl p-6 hover:border-yellow-500/50 transition-all duration-300">
                <div className="flex items-start gap-4">
                  <Award size={24} className="text-yellow-500 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="text-xl font-bold mb-2 text-yellow-500">
                      Second Best Film
                    </h3>
                    <p className="text-white font-semibold mb-1">Shape of Momo (Nepali)</p>
                    <p className="text-sm text-gray-400">Dir. Tribeny Rai</p>
                  </div>
                </div>
              </div>

              <div className="bg-white/5 border border-white/10 rounded-2xl p-6 hover:border-yellow-500/50 transition-all duration-300">
                <div className="flex items-start gap-4">
                  <Award size={24} className="text-yellow-500 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="text-xl font-bold mb-2 text-yellow-500">
                      Jury Special Mention Award
                    </h3>
                    <p className="text-white font-semibold mb-1">Anand Ravi</p>
                    <p className="text-sm text-gray-400">For Cinematography in 'Victoria'</p>
                  </div>
                </div>
              </div>

              <div className="bg-white/5 border border-white/10 rounded-2xl p-6 hover:border-yellow-500/50 transition-all duration-300">
                <div className="flex items-start gap-4">
                  <Award size={24} className="text-yellow-500 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="text-xl font-bold mb-2 text-yellow-500">
                      North East Spotlight Award
                    </h3>
                    <p className="text-white font-semibold mb-1">Noi Kotha (Assamese)</p>
                    <p className="text-sm text-gray-400">Dir. Pankaj Bora</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Panels Section */}
      <section className="py-20 bg-gradient-to-b from-black to-zinc-900">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-4xl md:text-5xl font-bold mb-4">
                FESTIVAL PANELS
              </h2>
              <p className="text-xl text-gray-400">
                Jury Committee
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-1 gap-8 max-w-3xl mx-auto">
              {/* Jury Panel - India Showcase */}
              <div className="bg-white/5 border border-white/10 rounded-2xl p-8">
                <h3 className="text-2xl font-bold mb-6 text-red-500">
                  JURY PANEL
                </h3>
                <p className="text-sm text-gray-400 uppercase tracking-wider mb-4">
                  India Showcase Competition
                </p>
                <div className="space-y-3">
                  <div>
                    <p className="font-bold">Girish Kasaravalli</p>
                    <p className="text-sm text-gray-400">Chairperson</p>
                  </div>
                  <div>
                    <p className="font-bold">Utpal Borpujari</p>
                  </div>
                  <div>
                    <p className="font-bold">Anupama Bose</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-20 bg-gradient-to-b from-black to-zinc-900">
        <div className="container mx-auto px-6">
          <div className="max-w-5xl mx-auto">
            <div className="grid grid-cols-2 md:grid-cols-5 gap-8 text-center">
              <div className="bg-white/5 border border-white/10 rounded-2xl p-8">
                <div className="text-5xl font-bold text-red-500 mb-2">220</div>
                <div className="text-sm uppercase tracking-widest text-gray-400">Films Submitted</div>
              </div>
              <div className="bg-white/5 border border-white/10 rounded-2xl p-8">
                <div className="text-5xl font-bold text-red-500 mb-2">{totalFilms}</div>
                <div className="text-sm uppercase tracking-widest text-gray-400">Total Films Screened</div>
              </div>
              <div className="bg-white/5 border border-white/10 rounded-2xl p-8">
                <div className="text-5xl font-bold text-red-500 mb-2">{asianCinema.length}</div>
                <div className="text-sm uppercase tracking-widest text-gray-400">Asian Cinema</div>
              </div>
              <div className="bg-white/5 border border-white/10 rounded-2xl p-8">
                <div className="text-5xl font-bold text-red-500 mb-2">{indianCompetition.length}</div>
                <div className="text-sm uppercase tracking-widest text-gray-400">Competition</div>
              </div>
              <div className="bg-white/5 border border-white/10 rounded-2xl p-8">
                <div className="text-5xl font-bold text-red-500 mb-2">{indianNonCompetition.length}</div>
                <div className="text-sm uppercase tracking-widest text-gray-400">Non-Competition</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />

      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default Gaff2026;
